import { ContentToggler } from './Container';

export function handleCloseTemplate(switchToClose: ContentToggler) {
  return (): void => {
    switchToClose();
  };
}

export function handleSwitchTemplate(
  switcher: ContentToggler,
  handleClose: () => void,
) {
  return (): void => {
    handleClose();
    switcher();
  };
}
